import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { initAppVersion } from './config/version';
import { registerServiceWorker } from './pwa/registerServiceWorker';
import { installAlertToneBridge } from './pwa/alertTone';
import './styles/globals.css';

initAppVersion();
void registerServiceWorker();
installAlertToneBridge();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
